import { httpWithAuth } from '~/clients';
import { GET_PURCHASE_DETAILS } from '~/constants/endpoints';
import type { PurchasingResponse } from '~/services/vdp/contracts';

export default function fetchUserPurchasing(controller?: AbortController) {
  return httpWithAuth
    .get<PurchasingResponse>(GET_PURCHASE_DETAILS, {
      signal: controller?.signal
    })
    .then(res => res.data);
}
